import React, { useState } from 'react';
import { loginMFA } from '../services/auth.service';
import { useAuth } from '../contexts/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../components/Button';
import { getUrlParams } from '../services/parameter.service';
import Feedback from '../components/Feedback';

const LoginMFARecoveryCode: React.FC = () => {
  const [code, setCode] = useState('');
  const [message, setMessage] = useState('');
  const [errorMessages, setErrorMessage] = useState([] as string[]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const { returnUrl } = getUrlParams();

  const { isLoggedIn } = useAuth();

  const isValidReturnUrl = (url: string) => {
    // Ensure it starts with a slash and is not a full URL with a protocol (http/https)
    return url && url.startsWith('/') && !url.startsWith('//');
  };

  const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await loginMFA(code, false, false, true);
      if (response.success) {
        if (returnUrl && isValidReturnUrl(returnUrl)) {
          window.location.href = returnUrl;
        } else {
          window.location.href = '/dashboard';
        }
      } else {
        setMessage('');
        setErrorMessage(response.errors);
        setLoading(false);
      }
    } catch (error) {
      setMessage('');
      setErrorMessage(['Invalid code']);
      setLoading(false);
    }
  };

  if (isLoggedIn && !returnUrl) {
    return <></>;
  }

  return (
    <div>
      <h2>Two-factor authentication</h2>
      <p>
        You have requested to log in with a recovery code. This login will not
        be remembered until you provide an authenticator app code at log in or
        disable 2FA and log in again.
      </p>
      <form onSubmit={handleLogin} className="login-form">
        <input
          type="text"
          id="code"
          placeholder="Recovery code"
          required
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
        <div className="button-container">
          <Button isLoading={loading} isSubmit={true}>
            Login
          </Button>
          <Button type="Outline" onClick={() => navigate('/')}>
            Cancel
          </Button>
        </div>
        <Feedback message={message} type="success" />
        <Feedback messages={errorMessages} type="error" />
        <div className="links">
          <Link to="/Policies/terms-of-use">Terms of Use</Link>|
          <Link to="/Policies/privacy-policy">Privacy Policy</Link>
        </div>
      </form>
    </div>
  );
};

export default LoginMFARecoveryCode;
